import { Button, DrawerFooter, Icons, Stack } from '@cast/design-system';

type EdgeLocationDrawerFooterProps = {
  submitButtonLabel: string;
  submitButtonTestId: string;
  isDisabled?: boolean;
  isLoading?: boolean;
  showSubmitIcon?: boolean;
  onClose: () => void;
  onSubmit: () => void;
  onBack?: () => void;
  backButtonTestId?: string;
};

export const EdgeLocationDrawerFooter = ({
  isDisabled = false,
  isLoading = false,
  submitButtonLabel,
  showSubmitIcon = true,
  submitButtonTestId,
  onClose,
  onBack,
  onSubmit,
  backButtonTestId,
}: EdgeLocationDrawerFooterProps) => {
  return (
    <DrawerFooter
      sx={{ justifyContent: onBack ? 'space-between' : 'flex-end' }}
      gap={8}
    >
      {!!onBack && (
        <Button
          testId={backButtonTestId}
          variant="ghost"
          onClick={onBack}
          startIcon={<Icons.ArrowLeft />}
        >
          Back
        </Button>
      )}
      <Stack direction="row" gap={8}>
        <Button variant="secondary" onClick={onClose}>
          Close
        </Button>
        <Button
          testId={submitButtonTestId}
          variant="primary"
          onClick={onSubmit}
          disabled={isDisabled}
          loading={isLoading}
          endIcon={showSubmitIcon ? <Icons.ArrowRight /> : undefined}
        >
          {submitButtonLabel}
        </Button>
      </Stack>
    </DrawerFooter>
  );
};
